<template>
  <section>
    <donate-header
      :amount="amount"
      :rawRepetition="
        paymentFrequency ? 'every ' + paymentFrequency : repetition
      "
      :stages="stageCount"
      :stageNumber="currentStage"
    />

    <donate-repetition v-if="repetition != 'once' && stage == 'repetition'" @nextStep="onNext" />

    <gift-aid v-if="stage == 'giftaid'" :amount="amount" @nextStep="onNext" />

    <donation-person-details v-if="stage == 'persondetails'" @nextStep="onNext" />

    <direct-debit
      v-if="stage == 'directdebit'"
      :amount="amount"
      :repetition="'Every ' + paymentFrequency"
      :startDate="collectionDate"
      @nextStep="onNext"
    />

    <stripe-payment
      v-show="stage == 'stripe'"
      @save="saveCardPayment"
      :public-key="stripePublicKey"
      :client-secret="stripeClientSecret"
    />
  </section>
</template>

<script>
import DonateHeader from "./DonateHeader.vue";
import DonateRepetition from "./DonateRepetition.vue";
import GiftAid from "./GiftAid.vue";
import DonationPersonDetails from "./DonatePersonDetails.vue";
import DirectDebit from "./DirectDebit.vue";
import StripePayment from "./StripePayment.vue";

export default {
  props: {
    amount: {
      type: Number,
      required: true,
    },

    campaign: {
      type: String,
      required: false,
      default: "Website-General",
    },

    repetition: {
      type: String,
      required: false,
      default: "regularly",
      validator: function (value) {
        // The value must match one of these strings
        return (
          ["once", "regularly", "annually", "quarterly", "monthly"].indexOf(
            value
          ) !== -1
        );
      },
    },

    stripePublicKey: {
      type: String,
      required: false,
    },

    stripeClientSecret: {
      type: String,
      required: false,
    },

    stripeIntentId: {
      type: String,
      required: false,
    },

    csrfTokenName: {
      type: String,
      required: false,
    },

    csrfToken: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      stage: null,
      currentStage: 2,

      // This lot is going to Donorfy
      firstName: null,
      lastName: null,
      emailAddress: null,
      addressLine1: null,
      addressLine2: null,
      town: null,
      county: null,
      postalCode: null,
      country: null,
      phone1: null,
      preferencesList: [],
      doGiftaid: false,
      paymentFrequency: null,
      collectionDay: null,
      collectionDate: null,
      accountName: null,
      sortCode: null,
      accountNumber: null,
    };
  },

  computed: {
    stageCount() {
      return this.repetition === "once" ? 4 : 5;
    },

    donorfyData() {
      const donorfyKeys = [
        "firstName",
        "lastName",
        "emailAddress",
        "addressLine1",
        "addressLine2",
        "town",
        "county",
        "postalCode",
        "country",
        "phone1",
        "preferencesList",
        "doGiftaid",
        "paymentFrequency",
        "collectionDay",
        "accountName",
        "sortCode",
        "accountNumber",
      ];

      const thisObj = Object.assign(this);

      const donorfyObj = Object.keys(thisObj)
        .filter((key) => donorfyKeys.includes(key))
        .reduce((obj, key) => {
          return {
            ...obj,
            [key]: thisObj[key],
          };
        }, {});

      // Props don't get put automagically
      donorfyObj.amount = this.amount;
      donorfyObj.campaign = this.campaign;

      return donorfyObj;
    },

    isOnce() {
      return this.stage === "once";
    },
  },

  methods: {
    onNext(dataUpdate) {
      // Send emitted values into data
      Object.assign(this, dataUpdate);
      this.currentStage++;

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });

      if (this.stage === "repetition") {
        this.stage = "giftaid";
        return;
      }

      if (this.stage === "giftaid") {
        this.stage = "persondetails";
        return;
      }

      if (this.stage === "persondetails") {
        if (this.repetition === "once") {
          this.stage = "stripe";
          this.saveCardPayment({ status: "started" });
        } else {
          this.stage = "directdebit";
        }
        return;
      }

      if ((this.stage === "directdebit")) {
        this.directDebit();
      }
    },

    saveCardPayment(result) {
      const payload = {
        ...this.donorfyData,
        ...result,
        stripeReference: this.stripeIntentId,
      };

      payload[this.csrfTokenName] = this.csrfToken;

      this.$axios
        .post("/donate/once", payload)
        .then((response) => {
          if (result.status === "received") {
            window.location = `/donate/thankyou?type=once&name=${this.firstName}&amount=${this.amount}`;
          }
        })
        .catch((error) => {
          console.log("error", error.response);
        });
    },

    directDebit() {
      const payload = {
        ...this.donorfyData,
      };

      payload[this.csrfTokenName] = this.csrfToken;

      this.$axios({
        method: "post",
        url: "/donate/regularly",
        data: payload,
      })
        .then((response) => {
          console.log(response);
          window.location = `/donate/thankyou?type=regular&name=${this.firstName}&amount=${this.amount}`;
        })
        .catch((error) => {
          console.log("error");
          // Handle error better…
          console.log(error.response);
        });
    },
  },

  mounted() {
    this.stage = this.repetition === "once" ? "giftaid" : "repetition";
  },

  components: {
    DonateHeader,
    DonateRepetition,
    GiftAid,
    DonationPersonDetails,
    DirectDebit,
    StripePayment,
  },
};
</script>
